import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import 'react-phone-input-2/lib/material.css';
import Stack from '@mui/material/Stack';

import { JsonViewer } from '@textea/json-viewer';

// The payload is stored as a raw JSON string, so it needs to be parsed before being
// handed to the JsonViewer, otherwise it just renders as an unreadable quoted string.
function parsePayload(eventDetails) {
  const raw = eventDetails?.payload ?? eventDetails;

  if (typeof raw !== 'string') {
    return raw;
  }

  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}

export default function EventDetailsDialog({ dialogOpen, eventDetails, okAction, ...other }) {
  return (
      <Dialog
        open={dialogOpen}
        maxWidth="sm"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
            <div>
              {"Event payload"}
            </div>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <JsonViewer value={parsePayload(eventDetails)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={okAction}>Ok</Button>
        </DialogActions>
      </Dialog>
  );
}

EventDetailsDialog.propTypes = {
  dialogOpen: PropTypes.bool,
  okAction: PropTypes.func,
  eventDetails: PropTypes.object,
};
